import { Quote } from 'lucide-react';

export const TestimonialCard = (props) => {
  const quote = props.quote;
  const author = props.author;
  const role = props.role;
  const organization = props.organization;
  const avatar = props.avatar;
  const variant = props.variant || "default";

  const isFeatured = variant === "featured";

  return (
    <div 
      className={`${
        isFeatured 
          ? 'card-highlight' 
          : 'card-base'
      } relative`}
      data-testid={`testimonial-${author.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <Quote 
        className={`w-10 h-10 mb-4 ${
          isFeatured ? 'text-white/30' : 'text-[#C8A24A]/30'
        }`} 
      />
      
      <blockquote className={`text-lg leading-relaxed mb-6 ${
        isFeatured ? 'text-green-50' : 'text-slate-700'
      }`}>
        "{quote}"
      </blockquote>
      
      <div className="flex items-center gap-4">
        {avatar ? (
          <img 
            src={avatar} 
            alt={author}
            className="w-12 h-12 rounded-full object-cover"
          />
        ) : (
          <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${
            isFeatured 
              ? 'bg-white/20 text-white' 
              : 'bg-[#F0FDF4] text-[#1F7A3A]'
          }`}>
            {author.charAt(0)}
          </div>
        )}
        <div>
          <p className={`font-semibold ${isFeatured ? 'text-white' : 'text-slate-900'}`}>
            {author}
          </p>
          <p className={`text-sm ${isFeatured ? 'text-green-200' : 'text-slate-500'}`}>
            {role}{organization ? `, ${organization}` : ''}
          </p>
        </div>
      </div>
    </div>
  );
};
